
export const RandomInt = {
	/** Random number between lower (inclusive) and upper (exclusive) */
	inRange(lower: number, upper: number): number {
		const lowerInt = Math.ceil(lower);
		return Math.floor(lowerInt + ((upper - lower) * Math.random()));
	}
};